import clsx from 'clsx';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Simulate } from 'react-dom/test-utils';
import EditorHeader from '../components/EditorHeader';
import KiteModel from '../components/KiteModel';
import PartList from '../components/PartList';
import useDraft from '../hooks/useDraft';
import { Part, PartType } from '../types';
import input = Simulate.input;

export default function PartsPage() {
    const { draft, updatePart } = useDraft();

    const [selectedPart, setSelectedPart] = useState<Part>();
    const [pendingPart, setPendingPart] = useState<boolean>(false);
    const [uncolored, setUncolored] = useState<boolean>();
    const [anchor, setAnchor] = useState<Element | null>(null);
    // useEffect(() => {
    //     if( anchor ) anchor.scrollIntoView({
    //         behavior: 'smooth',
    //         block: 'center'
    //     });
    // }, [anchor]);

    function handleSelectPart(part: Part) {
        if (selectedPart && selectedPart.id === part.id) {
            setSelectedPart(null);
            return;
        }
        setAnchor(document.querySelector(`#part-list-item-${part.id}`));
        setSelectedPart({
            ...part,
            notes: part.notes || '',
        });
    }

    function handlePartUpdate(key: keyof Part, value: any) {
        setSelectedPart({
            ...selectedPart,
            [key]: value,
        });
        setPendingPart(true);
    }

    useEffect(() => {
        if (!pendingPart) return undefined;
        const timeout = setTimeout(() => {
            updatePart(selectedPart);
            setPendingPart(false);
        }, 460);

        return () => clearTimeout(timeout);
    }, [selectedPart, pendingPart]);

    const materialFields: (keyof Part)[] = ['name', 'type', 'swatch', 'notes'];
    function renderSwitch(label: keyof Part, value: any) {
        switch (label) {
            default:
                return value;
            case 'swatch':
                return value
                    ? ['material', 'label', 'value']
                          .map((key) => value[key])
                          .join(' | ')
                    : 'not defined';
            case 'hidden':
                return (
                    <button
                        className={clsx('button button--small', {
                            ok: value,
                        })}
                    >
                        {value.toString()}
                    </button>
                );
            case 'notes':
                return (
                    <textarea
                        value={selectedPart.notes || ''}
                        onChange={({ target: { value } }) => {
                            handlePartUpdate('notes', value);
                        }}
                    />
                );
            case 'name':
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <input
                            type="text"
                            value={selectedPart.name}
                            onChange={({ target: { value } }) => {
                                handlePartUpdate('name', value);
                            }}
                        />
                        <button
                            className="button button--small"
                            onClick={() =>
                                handlePartUpdate('name', selectedPart.type)
                            }
                        >
                            set from type
                        </button>
                    </div>
                );
            case 'type':
                return (
                    <div className="control">
                        <select
                            value={selectedPart.type}
                            onChange={({ target: { value } }) => {
                                handlePartUpdate('type', value);
                            }}
                        >
                            {Object.values(PartType).map((type) => (
                                <option key={type} value={type}>
                                    {type === PartType.Rod
                                        ? `${type} (deprecated)`
                                        : type}
                                </option>
                            ))}
                        </select>
                    </div>
                );
        }
    }

    return (
        <div className="parts" key={draft.id}>
            <PartList
                parts={draft.parts}
                selected={selectedPart}
                onSelect={handleSelectPart}
            />
            <div className="parts__view parts__sticker">
                <div className="">
                    <EditorHeader />
                    <KiteModel
                        className={'no-hover'}
                        svg={draft.svg}
                        selected={selectedPart}
                        uncolored={uncolored}
                        onClick={handleSelectPart}
                    />
                    <hr />
                    <button
                        className={clsx('button button--small', {
                            isSelected: !uncolored,
                        })}
                        onClick={() => setUncolored(!uncolored)}
                    >
                        colors on/off
                    </button>
                    <hr />
                    {selectedPart &&
                        materialFields
                            .map((label) => [label, selectedPart[label]])
                            .map(([label, value], index) =>
                                label !== 'color' ? (
                                    <dl key={label as string}>
                                        <dt>{label}</dt>
                                        <dd>
                                            {renderSwitch(
                                                label as keyof Part,
                                                value
                                            )}
                                        </dd>
                                    </dl>
                                ) : (
                                    `simple panel: ${value}`
                                )
                            )}
                </div>
            </div>
        </div>
    );
}
